const config = {
    apiUrl: process.env.GATSBY_API_URL || "http://internal-elaris:7082",
    portalUrl: process.env.GATSBY_PORTAL_URL || "/portal",
    authUrl: process.env.GATSBY_AUTH_URL || ""
}

export default config;